// Components
import BulletDesktopContainer from '@/components/global-components/bullet/sub-components/BulletDesktopContainer';
import Carousel from '@/components/global-components/carousel/Carousel';
import Bullet from '@/components/global-components/bullet/Bullet';

// Node Modules
import { nanoid } from 'nanoid';

// Themes
import theme from '@/themes/index';

const Highlights = ({
  content: {
    title,
    highlights, 
  },
  isMobile,
  isDesktop,
}) => {
  const getHighlightsForDesktopViewPort = () => (
    <BulletDesktopContainer
      bullets={highlights}
      bulletStylesContainer={{
        paddingBottom: '0',
      }}
    />
  );

  const getHighlightsForMobileViewPort = () => (
    <Carousel slidesToShow={1.1} cellSpacing={15} showPaging={true}>
      {highlights.map(item => (
        <Bullet key={nanoid()} isMobile={isMobile} content={item.highlight} />
      ))}
    </Carousel>
  );

  return (
    <>
      <div className='highlights-container'>
        <h4>{title}</h4>
        {isDesktop
          ? getHighlightsForDesktopViewPort()
          : getHighlightsForMobileViewPort()}
      </div>
      <style jsx>{`
        div.highlights-container {
          text-align: center;
          display: flex;
          flex-direction: column;
        }

        div.highlights-container h4 {
          font-family: ${theme.fontFamilies.montserratBold};
          line-height: 1.875rem;
          margin-block-start: 0;
          margin-block-end: 4rem;
          margin-inline-start: 0;
          margin-inline-end: 0;
        }

        div.highlights-container .bullets-container {
          display: flex;
          width: 100%;
          flex-direction: row;
          gap: 1.5rem;
          justify-content: space-between;
        }
        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          div.highlights-container h4 {
            line-height: 3.75rem;
          }
        }
      `}</style>
    </>
  );
};

export default Highlights;
